<template>
    <div class="countryList">
        <CountryListItem v-for="(item,index) in countryInfo" :key="index" :countryItemInfo="item" />
    </div>
</template>

<script>
    import CountryListItem from "./countryListItem" 
    export default {
        components:{
            CountryListItem
        },
        props:{
            countryInfo:{
                type:Array,
                default(){
                    return []
                }
            }
        }
    }
</script>
<style scoped>
 /* 国家 */
    .countryList{
        overflow: hidden;
    }
    
</style>